import { render, staticRenderFns } from "./MeasureUnitCreateView.vue?vue&type=template&id=2c17d180"
import script from "./MeasureUnitCreateView.vue?vue&type=script&lang=js"
export * from "./MeasureUnitCreateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports